import React from 'react';
import { Divider, Typography } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { savedConfigurationCalculationState } from '../../store/calculation';
import { ComplementaryProduct } from '../ComplementaryProduct';
import { AddedProductsTitle, ComplimentaryProductInfoContainer } from './styles';

export const ComplementaryProductsList = () => {
  const { complementaryProducts, complimentaryGroups } = useRecoilValue(savedConfigurationCalculationState);

  const totalComplimentaryProductCount = complementaryProducts.length;
  const hasGroups = !!complimentaryGroups.length;

  if (!totalComplimentaryProductCount && !hasGroups) {
    return null;
  }

  return (
    <>
      <AddedProductsTitle>
        <Typography variant="h3">Подобрали инструменты и расходники</Typography>
      </AddedProductsTitle>
      <ComplimentaryProductInfoContainer>
        {complementaryProducts.map((item, i) => (
          <React.Fragment key={item.code}>
            <ComplementaryProduct
              photo={item.image}
              displayedName={item.name}
              count={item.quantity}
              price={item.price}
              productId={item.code}
              productPageName={item.productPageName}
            />
            {(totalComplimentaryProductCount - 1 !== i || hasGroups) && <Divider />}
          </React.Fragment>
        ))}

        {complimentaryGroups.map((group, groupIndex) => {
          const selectedProduct = group.products.find(product => product.code === group.selectedProductId);

          if (!selectedProduct) return null;

          return (
            <React.Fragment key={group.groupName}>
              <ComplementaryProduct
                photo={selectedProduct.image}
                displayedName={selectedProduct.name}
                count={selectedProduct.quantity}
                price={selectedProduct.price}
                productId={selectedProduct.code}
                productPageName={selectedProduct.productPageName}
                productVariants={group.variants}
                groupName={group.groupName}
              />
              {groupIndex !== complimentaryGroups.length - 1 && <Divider />}
            </React.Fragment>
          );
        })}
      </ComplimentaryProductInfoContainer>
    </>
  );
};
